import type { TokenInfo } from "@/api";
import { SOL_ADDRESS } from "./constants";

export function isNativeSol(token: TokenInfo): boolean {
  return token.address === SOL_ADDRESS && token.symbol?.toUpperCase() === "SOL";
}
